import { Center, List, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CompaniesPieColors } from 'slices/modules/companies/companiesPieColors';
import PieChartCompanyListItem from './PieChartListItem';

interface CompanyListItem {
  name: string;
  volumePercent: number;
}

interface Props {
  items: CompanyListItem[];
  pieColors: CompaniesPieColors;
}

const PieChartCompanyList: FC<Props> = ({ items, pieColors }) => {
  const { t } = useTranslation();

  if (items.length > 0) {
    return (
      <List w="100%" maxW="300px">
        {items.map((item, index) => (
          <PieChartCompanyListItem
            key={index}
            name={item.name}
            balancePercent={item.volumePercent}
            color={pieColors[item.name]}
          />
        ))}
      </List>
    );
  } else {
    return (
      <Center w="100%">
        <Text textAlign="center">{t('listIsEmpty')}</Text>
      </Center>
    );
  }
};

export default PieChartCompanyList;
